import { createStore } from 'vuex'

export default createStore({
  state: {
    sharedVariable: ''
  },
  getters: {
  },
  mutations: {
    updateVariable(state, newValue) {
      state.sharedVariable = newValue;
    }
  },
  actions: {
    setSharedVariable({ commit }, newValue) {
      commit('updateVariable', newValue);
    }
  },
  modules: {
  }
})
